import { useContext } from 'react';
import { AppContext } from '../../context/AppContext';

function Resource () {

	const { setResourceOpen } = useContext(AppContext);

	return (
		<div className="dataSourceModal">
			<div className="modalHead">
			<div type="button" className="tit">
					<img src="img/headerIcon02.png" alt="icon" />
					데이터 출처
			</div>
			<div type="button" className="CloseIconButton">
				<img src="img/popCloseBtn.png" alt="닫기" onClick={() => setResourceOpen(false)} />
			</div>
			</div>

			<div className="dataSourceTable">
              <table>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>데이터</th>
                    <th>기준년도</th>
                    <th>출처</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>유입·유출 중심성 지수</td>
                    <td>1kmX1km 격자 단위 OD(자택 주소지-직장 주소지)</td>
                    <td>2021년</td>
                    <td>KCB</td>
                  </tr>
                  <tr>
                    <td>거주인구</td>
                    <td>1kmX1km 격자 단위 인구주택 총조사 인구</td>
                    <td>2021년</td>
                    <td>SGIS(통계청)</td>
                  </tr>
                  <tr>
                    <td>근무인구</td>
                    <td>1kmX1km 격자 단위 직장 주소지 기준 인구</td>
                    <td>2021년</td>
                    <td>KCB</td>
                  </tr>
                </tbody>
              </table>
            </div>
		</div>
	)
}

export default Resource;